import React, { Component } from 'react';
import * as ExpressPutAwayAction from '../actions/ExpressPutAwayAction';
import ExpressPutAwayStore from '../stores/ExpressPutAwayStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import * as MenuAction from '../actions/MenuAction';
import Button from '@material-ui/core/Button';
import { display } from '@material-ui/system';
import swal from 'sweetalert';
let currentPagePath;
class ExpressPutAwayComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            BusUnitDD: [],
            BinLocationDD: [],
            BinLocOptions: [],
            BuOptions: [],
            BuDDName: "",
            BuDDValue: "",
            Area: [], SelectedArea: "",
            Aisle: [], SelectedAisle: "",
            Row: [], SelectedRow: "",
            Shelf: [], SelectedShelf: "",
            Bin: [], SelectedBin: "",
            WorkOrder: "",
            Cost: "",
            Quantity: "",
            ItemID: "",
            IsMakedefchk: false,
            ErrItemId: "",
            ErrWorkOrder: "",
            ErrQuantity: "",
            ErrCost: "",
            isFavorited: false,
            isWorkToStoreValid: false,
            UOMValue: "",
            UOMName: "",
            UOMOptions: [],
            ItemDesc: "",
            ItemUOM: ""
        }
    }
    componentDidMount() {

        
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.PageLoad();
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        ExpressPutAwayAction.getCurrentFavPage(getFavPageBO);
        ExpressPutAwayStore.on('PageLoad', this.PageLoadResponse);
        ExpressPutAwayStore.on('SaveItem', this.SaveItemClickResponse);
        ExpressPutAwayStore.on('SearchItem', this.SearchItemClickResponse);
        ExpressPutAwayStore.on('favpage', this.loadFavPageResponse.bind(this));
        ExpressPutAwayStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        ExpressPutAwayStore.on('WOfail', this.workorderfail);
        ExpressPutAwayStore.on('workordercheck', this.Workorderresponse);
    }
    componentWillUnmount() {
        ExpressPutAwayStore.removeListener('PageLoad', this.PageLoadResponse);
        ExpressPutAwayStore.removeListener('SaveItem', this.SaveItemClickResponse);
        ExpressPutAwayStore.removeListener('SearchItem', this.SearchItemClickResponse);
        ExpressPutAwayStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        ExpressPutAwayStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
        ExpressPutAwayStore.removeListener('WOfail', this.workorderfail);
        ExpressPutAwayStore.removeListener('workordercheck', this.Workorderresponse);
    }
    //This Method is used to get Business Unit and Location Detail based on User's Bu
    PageLoad = () => {
        let PageLoadBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ExpressPutAwayAction.PageLoad(PageLoadBO);
    }
    //To Store Business Unit and Location Detail
    PageLoadResponse = () => {
        
        let PageLoadData = JSON.parse(ExpressPutAwayStore.PageLoadData);
        let BusUnitDD = PageLoadData.BusUnit;
        //BusUnitDD = BusUnitDD.filter((ele, ind) => ind === BusUnitDD.findIndex(elem => elem.BUSINESS_UNIT === ele.BUSINESS_UNIT ))
        let BinLocationDD = PageLoadData.BinLocation;
        //let UOMDD = PageLoadData.UOMDD;
        this.BusUnitDD(BusUnitDD);
        //this.UOMDD(UOMDD);
        //this.BinLocationDD(BinLocationDD);
        this.setState({
            BusUnitDD: BusUnitDD, BinLocationDD: BinLocationDD
        });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    UOMDD = (UOMDD) => {
        
        let UOMDDvalue = []
        if (UOMDD.length > 0) {
            UOMDD.map((val, index) => {
                let localArray = {
                    value: val.UNIT_OF_MEASURE,
                    label: val.DESCR,
                }
                UOMDDvalue.push(localArray)

            });
        }
        this.setState({ UOMOptions: UOMDDvalue });

    };
    //To loop the Business Unit Data for Business Unit Dropdown
    BusUnitDD = (BusUnitDD) => {
        
        let BusUnitDDvalue = []
        if (BusUnitDD.length > 0) {
            BusUnitDD.map((val, index) => {
                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCR,
                }
                BusUnitDDvalue.push(localArray)

            });
        }
        this.setState({ BuOptions: BusUnitDDvalue });

    };
    //To loop the Bin Location Data for Location Dropdown
    BinLocationDD = (BinLocationDD) => {
        
        let BinLocvalue = []
        if (BinLocationDD.length > 0) {
            BinLocationDD.map((val, index) => {
                let localArray = {
                    value: val.STORAGE_AREA,
                    label: val.STORAGE_AREA,
                }
                BinLocvalue.push(localArray)

            });
        }
        let locArea = BinLocationDD
        this.setState({ BinLocOptions: BinLocvalue });
    };
    handleUOMChange = (e) => {
        
        let a = e;
        this.setState(
            { UOMName: e.label, UOMValue: e.value });
    }
    //This method is invoked when user selects Business Unit 
    handleBUDDChange = (e) => {
        
        let Areadd = [];
        let a = e.value;
        this.state.BinLocationDD.map((item, index) => {
            if (item.BUSINESS_UNIT == e.value && Areadd.indexOf(item.STORAGE_AREA) == -1) {
                let obj = {
                    value: item.STORAGE_AREA,
                    label: item.STORAGE_AREA
                }
                Areadd.push(obj);
            }
        })
        let locArea = Areadd.filter((ele, ind) => ind === Areadd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //9/23/22, Bug - 2678, To make the dependency dropdowns empty based on the selected value of crib ID changes, Dhevanesam R] 
        if (this.state.BuDDName != null && this.state.BuDDName != " " && this.state.BuDDName != "" && this.state.BuDDName != undefined) {
            
            if (this.state.BuDDName == e.label) {
                this.setState(
                    { BuDDName: e.label, BuDDValue: e.value, Area: locArea, ItemDesc: "", ItemUOM: "" });
            }
            else {
                this.setState({ BuDDName: e.label, BuDDValue: e.value, Area: locArea, ItemDesc: "", ItemUOM: "", SelectedArea: "", SelectedAisle: "", SelectedRow: "", SelectedShelf: "", SelectedBin: "", Aisle: [], Row: [], Shelf: [], Bin: [] })
            }
        }
        else {
            this.setState(
                { BuDDName: e.label, BuDDValue: e.value, Area: locArea, ItemDesc: "", ItemUOM: "" });
        }


    }
    //This method is invoked when user selects Area DropDown
    selectAreaChange = (e) => {
        
        let area = e;
        let Aisledd = [];
        this.state.BinLocationDD.map((item, index) => {
            //9/23/22, Bug - 2678, To load the dropdown value based on crib ID selected, Dhevanesam R] 
            if (item.BUSINESS_UNIT == this.state.BuDDValue && item.STORAGE_AREA == e.value && Aisledd.indexOf(item.STOR_LEVEL_1) == -1) {
                let obj = {
                    value: item.STOR_LEVEL_1,
                    label: item.STOR_LEVEL_1
                }
                Aisledd.push(obj);
            }
        })
        let pp = Aisledd.filter((ele, ind) => ind === Aisledd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //this.setState({ Aisle: pp, SelectedArea: e.value });
        //this.setState({ Aisle: pp, SelectedArea: area });
        //9/21/22, Bug - 2678, To make the dependency dropdowns empty based on the selected value changes, Dhevanesam R] 
        if (this.state.SelectedArea != null && this.state.SelectedArea != " " && this.state.SelectedArea != "" && this.state.SelectedArea != undefined) {
            if (this.state.SelectedArea.value == area.value) {
                this.setState({ Aisle: pp, SelectedArea: area })
            }
            else {
                this.setState({ Aisle: pp, Row: [], Shelf: [], Bin: [], SelectedArea: area, SelectedAisle: "", SelectedRow: "", SelectedShelf: "", SelectedBin: "" })
            }
        }
        else {
            this.setState({ Aisle: pp, Row: [], Shelf: [], Bin: [], SelectedArea: area, SelectedAisle: "", SelectedRow: "", SelectedShelf: "", SelectedBin: "" })
        }
        console.log("Aislecon", this.state.SelectedArea);
    }

    //This method is invoked when user selects Aisle DropDown 
    selectAisleChange = (e) => {
        
        let aisle = e;
        let Rowdd = [];
        this.state.BinLocationDD.map((item, index) => {
            //9/23/22, Bug - 2678, To load the dropdown value based on crib ID selected, Dhevanesam R] 
            if (item.BUSINESS_UNIT == this.state.BuDDValue && item.STORAGE_AREA == this.state.SelectedArea.value && item.STOR_LEVEL_1 == e.value
                && Rowdd.indexOf(item.STOR_LEVEL_2) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_2,
                    label: item.STOR_LEVEL_2
                }
                Rowdd.push(obj);
            }
        })
        let pp = Rowdd.filter((ele, ind) => ind === Rowdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //this.setState({ Row: pp, SelectedAisle: aisle })
        //9/21/22, Bug - 2678, To make the dependency dropdowns empty based on the selected value changes, Dhevanesam R] 
        if (this.state.SelectedAisle != null && this.state.SelectedAisle != " " && this.state.SelectedAisle != "" && this.state.SelectedAisle != undefined) {
            if (this.state.SelectedAisle.value == aisle.value) {
                this.setState({ Row: pp, SelectedAisle: aisle })
            }
            else {
                this.setState({ Row: pp, Shelf: [], Bin: [], SelectedAisle: aisle, SelectedRow: "", SelectedShelf: "", SelectedBin: "" })
            }
        }
        else {
            this.setState({ Row: pp, Shelf: [], Bin: [], SelectedAisle: aisle, SelectedRow: "", SelectedShelf: "", SelectedBin: "" })
        }
    }
    //This method is invoked when user selects Row DropDown 
    selectRowChange = (e) => {
        
        let row = e;
        let Shelfdd = [];
        this.state.BinLocationDD.map((item, index) => {
            //9/23/22, Bug - 2678, To load the dropdown value based on crib ID selected, Dhevanesam R] 
            if (item.BUSINESS_UNIT == this.state.BuDDValue && item.STORAGE_AREA == this.state.SelectedArea.value && item.STOR_LEVEL_1 == this.state.SelectedAisle.value
                && item.STOR_LEVEL_2 == e.value && Shelfdd.indexOf(item.STOR_LEVEL_3) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_3,
                    label: item.STOR_LEVEL_3
                }
                Shelfdd.push(obj);
            }
        })
        let pp = Shelfdd.filter((ele, ind) => ind === Shelfdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //this.setState({ Shelf: pp, SelectedRow: row })
        //9/21/22, Bug - 2678, To make the dependency dropdowns empty based on the selected value changes, Dhevanesam R] 
        if (this.state.SelectedRow != null && this.state.SelectedRow != " " && this.state.SelectedRow != "" && this.state.SelectedRow != undefined) {
            if (this.state.SelectedRow.value == row.value) {
                this.setState({ Shelf: pp, SelectedRow: row })
            }
            else {
                this.setState({ Shelf: pp, Bin: [], SelectedRow: row, SelectedShelf: "", SelectedBin: "" })
            }
        }
        else {
            this.setState({ Shelf: pp, Bin: [], SelectedRow: row, SelectedShelf: "", SelectedBin: "" })
        }
    }
    //This method is invoked when user selects Shelf DropDown 
    selectShelfChange = (e) => {
        
        let shelf = e;
        let Bindd = [];
        this.state.BinLocationDD.map((item, index) => {
            //9/23/22, Bug - 2678, To load the dropdown value based on crib ID selected, Dhevanesam R] 
            if (item.BUSINESS_UNIT == this.state.BuDDValue && item.STORAGE_AREA == this.state.SelectedArea.value && item.STOR_LEVEL_1 == this.state.SelectedAisle.value
                && item.STOR_LEVEL_3 == e.value && item.STOR_LEVEL_2 == this.state.SelectedRow.value && Bindd.indexOf(item.STOR_LEVEL_4) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_4,
                    label: item.STOR_LEVEL_4
                }
                Bindd.push(obj);
            }
        })
        let pp = Bindd.filter((ele, ind) => ind === Bindd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //this.setState({ Bin: pp, SelectedShelf: shelf})
        //9/21/22, Bug - 2678, To make the dependency dropdowns empty based on the selected value changes, Dhevanesam R] 
        if (this.state.SelectedShelf != null && this.state.SelectedShelf != " " && this.state.SelectedShelf != "" && this.state.SelectedShelf != undefined) {
            if (this.state.SelectedShelf.value == shelf.value) {
                this.setState({ Bin: pp, SelectedShelf: shelf })
            }
            else {
                this.setState({ Bin: pp, SelectedShelf: shelf, SelectedBin: "" })
            }
        }
        else {
            this.setState({ Bin: pp, SelectedShelf: shelf, SelectedBin: "" })
        }
    }
    //This method is invoked when user selects Bin DropDown 
    selectBinChange = (e) => {
        
        let bin = e;
        this.setState({ SelectedBin: bin })
    }
    clearItemId = (type) => {
        if (type == "ItemId") {
            this.setState({ ItemID: "", ItemDesc: "", ItemUOM: "" });
        }
        if (type == "WorkOrder") {
            this.setState({ WorkOrder: "" });
        }
    }
    //This method is invoked when user Enters any one of Item Id or WorkOrder or Cost or Quantity text box
    HandleChange = (e, type) => {
        
        const costre = SDIConstants.CostRegEx;
        const re = SDIConstants.quantityRegEX;
        let regex = SDIConstants.alphanumericRegex
        let RegExp = /^\d*\.?\d*$/;
        if (type == "ItemId") {
            //Bug 5494 - Hide the Desc and UOM field when clear the Item Id- Nandhini L
            let val = e.target.value;
            if (val.length == 0) {
                this.setState({ ItemDesc: "", ItemUOM: ""})
            }
            this.setState({ [e.target.name]: e.target.value });
        }
        else if (type == "Quantity") {
            
            if (e.target.value === '' || re.test(e.target.value)) {
                if (e.target.value != "0") {
                    this.setState({ [e.target.name]: e.target.value });
                }
            }
        }
        else if (type == "Cost") {
            if (e.target.value === '' || RegExp.test(e.target.value)) {
                if (e.target.value != "0") {
                    if (e.target.value.includes('.')) {
                        let ind = e.target.value.indexOf('.');
                        let Rem = e.target.value.substring(ind + 1, e.target.value.length + 1);
                        if (Rem.length > 2) {
                            e.preventDefault();
                        }
                        else {
                            this.setState({ [e.target.name]: e.target.value });
                        }
                    }
                    else {
                        this.setState({ [e.target.name]: e.target.value });
                    }
                }
            }
        }
        else if (type == "WorkOrder") {
            //WW-742_PC_08 -Aparna
            const onlyNumbers = SDIConstants.quantityRegEX;
            if (e.target.value === '' || onlyNumbers.test(e.target.value)) {
                this.setState({ [e.target.name]: e.target.value, WONUM: e.target.value });
            }
        }
        else if (type == "checkbox") {
            this.setState({ IsMakedefchk: e.target.checked });
        }
        else if (type == "Description") {
            this.setState({ [e.target.name]: e.target.value });
        }
    };
    //WW-38 Need to add Description and Unit Of Measure (UOM) fields to Express Put Away page. UOM should be shown in all Transaction pages - Deepthi
    SearchItemClick = () => {
        if (this.state.ItemID != "" && this.state.BuDDValue != "") {
            let SearchItemBO = {
                ItemID: this.state.ItemID.toUpperCase(),
                SelectedBU: this.state.BuDDValue
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ExpressPutAwayAction.SearchItem(SearchItemBO)
        }
        else {
            if (this.state.BuDDName == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please select Crib ID '
                });
                // alert('Please Select Business Unit');
            }
            else if (this.state.ItemID == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please enter item ID'
                });
                // alert('Please Enter Item ID')
            }

        }
        //this.setState({ ErrItemId: ItemIdErr, ErrQuantity: QuantityErr, ErrCost: CostErr });

    }
    //WW-38 Need to add Description and Unit Of Measure (UOM) fields to Express Put Away page. UOM should be shown in all Transaction pages - Deepthi
    SearchItemClickResponse = () => {
        
        let SearchData = JSON.parse(ExpressPutAwayStore.SearchItemData);
        let ItemMsg = SearchData[0].ItemIdErrMsg;
        if (ItemMsg == undefined) {
            this.setState({ ItemDesc: SearchData[0].DESCR60, ItemUOM: SearchData[0].UNIT_MEASURE_STD });
        }
        else if (ItemMsg != "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: ItemMsg
            });
            //alert(ItemMsg);
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //This method is invoked when user clicks on the Save Button
    SaveItemClick = () => {
        //let ItemIdErr = "";
        //let QuantityErr = "";
        //let CostErr = "";
        
        if (this.state.ItemID != "" && this.state.Quantity != "" && this.state.Cost != "" && this.state.SelectedArea != "" &&
            this.state.SelectedAisle != "" && this.state.SelectedRow != "" && this.state.SelectedShelf != "" && this.state.SelectedBin != "") {
            let SaveItemBO = {
                Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                SelectedBU: this.state.BuDDValue,
                ItemID: this.state.ItemID.toUpperCase(),
                Comment: "",
                WorkOrder: this.state.WorkOrder,
                Cost: this.state.Cost,
                Quantity: this.state.Quantity,
                Area: this.state.SelectedArea.value,
                Aisle: this.state.SelectedAisle.value,
                Row: this.state.SelectedRow.value,
                Shelf: this.state.SelectedShelf.value,
                Bin: this.state.SelectedBin.value,
                MakeDefaultChk: this.state.IsMakedefchk
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ExpressPutAwayAction.SaveItems(SaveItemBO)
        }
        else {
            //5633 - updated please select a business unit to crib ID [4/16/2025] Nachiappan
            if (this.state.BuDDName == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please select Crib ID'
                });
                //alert('Please Select Business Unit');
            }
            else if (this.state.ItemID == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please enter item ID'
                });
                //  alert('Please Enter Item ID')
            }
            else if (this.state.Quantity == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please enter quantity'
                });
                // alert('Please Enter Quantity')
            }
            else if (this.state.Cost == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please enter cost'
                });
                //    alert('Please Enter Cost')
            }
            else if (this.state.SelectedArea == "NON" || this.state.SelectedArea == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please select area'
                });
                // alert('Please Select Area')
            }
            else if (this.state.SelectedAisle == "NON" || this.state.SelectedAisle == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please select aisle'
                });
                // alert('Please Select Aisle')
            }
            else if (this.state.SelectedRow == "NON" || this.state.SelectedRow == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please select row'
                });
                // alert('Please Select Row')
            }
            else if (this.state.SelectedShelf == "NON" || this.state.SelectedShelf == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please select shelf'
                });
                // alert('Please Select Shelf')
            }
            else if (this.state.SelectedBin == "NON" || this.state.SelectedBin == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please select bin'
                });
                //alert('Please Select Bin')
            }
            //this.setState({ ErrItemId: ItemIdErr, ErrQuantity: QuantityErr, ErrCost: CostErr });
        }

    }
    //This method brings back the response of insertion status of the Item
    SaveItemClickResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let SaveItemResponse = JSON.parse(ExpressPutAwayStore.SaveItemData);
        let ItemSaveRes = SaveItemResponse.ResultTable;
        let ItemIDRes = ItemSaveRes[0].ItemIdErrMsg;
        let WorkOrderRes = ItemSaveRes[0].WorkOrderErrMsg;
        let SuccessMsgRes = ItemSaveRes[0].SuccessMessage;
        if (ItemIDRes != "" && WorkOrderRes != "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Entered item Id and workorder is invalid'
            });
            //  alert('Entered Item Id and WorkOrder is Invalid');
        }
        else if (ItemIDRes != "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: ItemIDRes
            });
            // alert(ItemIDRes);
        }
        else if (WorkOrderRes != "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: WorkOrderRes
            });
            // alert(WorkOrderRes);
        }
        else if (SuccessMsgRes != "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: SuccessMsgRes
            });
            //   alert(SuccessMsgRes);
            //9/26/22, Bug - 2678, To empty the options for the dropdowns once the item is submitted, Dhevanesam R]
            this.setState({
                SelectedArea: "", SelectedAisle: "", SelectedBin: "", SelectedRow: "", SelectedShelf: "", ItemDesc: "",
                ItemUOM: "", BuDDName: "", WorkOrder: "", ItemID: "", Cost: "", Quantity: "", IsMakedefchk: false, Area: [], Aisle: [], Row: [], Shelf: [], Bin: []
            });
        }
    }
    //To handle the favorite page
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Express Putaway",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ExpressPutAwayAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ExpressPutAwayAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let favPageResponse = JSON.parse(ExpressPutAwayStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (ExpressPutAwayStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ExpressPutAwayStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ExpressPutAwayStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };
    WorkOrderInputCheck = () => {
        if (this.state.WONUM == undefined || this.state.WONUM == null || this.state.WONUM == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter work order'
            });
            // alert('Please Enter Work Order');
            return;
        }
        else {
            if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                let THIRDPARTY_COMP_ID = ""
                if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                    THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
                }
                let BO = {
                    workOrder: this.state.WorkOrder,
                    Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');

                ExpressPutAwayAction.WorkOrderCheck(BO)
            }
            else {
                this.setState({ isWorkToStoreValid: true });
            }
        }

    }
    Workorderresponse = () => {
        
        let Workorderresponse = JSON.parse(ExpressPutAwayStore.workorderresponse);
        let workorder;
        let loacalloc = "";
        let validation = false;
        //WAL-1034_PC_0
        if (Workorderresponse.WOResponse) {
            if (Workorderresponse.WOResponse.length > 0) {
                //WW-1374 Update the WO store, logo, Problem code long and short description to cookie - Nandhini L 
                loacalloc = Workorderresponse.WOResponse[0].LOCATION
                localStorage.setItem("StoreValue", JSON.stringify(loacalloc));

                CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);
                CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
                CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
                CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);

                workorder = Workorderresponse.WOResponse;
                if (Workorderresponse.WOResponse[0].ADDRESS1 != "" && Workorderresponse.WOResponse[0].ADDRESS1 != null && Workorderresponse.WOResponse[0].ADDRESS1 != undefined && Workorderresponse.WOResponse[0].ADDRESS1 != " ") {
                    validation = true;
                }
                else {
                    validation = false;
                }

            }
        }
        if (validation) {
            
            this.setState({ isWorkToStoreValid: true });
        } else {
            this.setState({ isWorkToStoreValid: false });
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Entered work order is invalid'
            });
            //  alert('Entered Work Order Is Invalid');
            return;
        }
    }
    workorderfail = () => {
        
        if (this.state.submitbtn == true) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Enter valid work order #'
            });
            //  alert('Please Enter Valid Work Order');
            this.setState({ submitbtn: false })
        } else {
            this.setState({ isWorkToStoreValid: false });
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Enter valid work order #'
            });
            // alert('Please Enter Valid Work Order');
        }
    }

    render() {
        return (<div className="container-fluid content-margin" style={{ "marginTop": "11%" }}>
            <div className="col-md-12 page-heading mb-3 float-left p-0">
                <h5 className="page-title">Express Putaway</h5>
                <div className="fav-item-maintenance-icon mt-1">
                    <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                    <label htmlFor="checkbox-OrdStatus">
                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                </g>
                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                </g>
                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                </g>
                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                </g>
                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                </g>
                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                </g>
                                <g className="grp1" opacity={0} transform="translate(24)">
                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                </g>
                            </g>
                        </svg>
                    </label>
                </div>
            </div>
            {/*9/21/22, Bug - 2678, To add mandatory symbol to all teh mandatory fields, Dhevanesam R] */}
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="catalog-label mandatory-after w-100">Crib ID</label>
                            <span style={{ "fontSize": "14px" }}><Select
                                id="businessUnit"
                                name="BuDD"
                                onChange={(e) => this.handleBUDDChange(e)}
                                value={{ label: this.state.BuDDName }}
                                options={this.state.BuOptions}
                            /></span>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="catalog-label W-100" htmlFor="workOrder">Work Order</label>
                            {/*<input type="text" name="WorkOrder" value={this.state.WorkOrder} onChange={e => this.HandleChange(e, "WorkOrder")} className="form-control" id="workOrder" />*/}

                            <div className="input-group charge-code-group mb-2" style={{ "marginTop": "33px" }}>{/*col-lg-6 col-md-12 float-left p-0 col-12**/}
                                <input type="text" name="WorkOrder" value={this.state.WorkOrder} onChange={e => this.HandleChange(e, "WorkOrder")} className="form-control charge-code-control" maxLength="9" defaultValue={''} />
                                <span className={this.state.WorkOrder != null && this.state.WorkOrder != "" && this.state.WorkOrder != " " ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "float": "left", "marginRight": '0px', "marginTop": '0px', "right": '50px' }} onClick={() => this.clearItemId("WorkOrder")}></span>
                                <div class="input-group-append">
                                    <span className="input-group-text" onClick={(e) => this.WorkOrderInputCheck(e)} >
                                        <span className="shopping-search-icon" />
                                    </span>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="catalog-label mandatory-after W-100" htmlFor="ItemID">Item ID</label>
                            {/*<input type="text" name="WorkOrder" value={this.state.WorkOrder} onChange={e => this.HandleChange(e, "WorkOrder")} className="form-control" id="workOrder" />*/}

                            <div className="input-group charge-code-group mb-2" style={{ "marginTop": "33px" }}>{/*col-lg-6 col-md-12 float-left p-0 col-12**/}
                                <input type="text" name="ItemID" value={this.state.ItemID} onChange={e => this.HandleChange(e, "ItemId")} className="form-control charge-code-control" maxLength="9" defaultValue={''} />
                                <span className={this.state.ItemID != null && this.state.ItemID != "" && this.state.ItemID != " " ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "float": "left", "marginRight": '0px', "marginTop": '0px', "right": '50px' }} onClick={() => this.clearItemId("ItemId")}></span>
                                <div class="input-group-append">
                                    <span className="input-group-text" onClick={(e) => this.SearchItemClick(e)} >
                                        <span className="shopping-search-icon" />
                                    </span>
                                </div>

                            </div>
                            {/*<label className="catalog-label" htmlFor="itemId">Item ID</label>
                            <input type="text" name="ItemID" value={this.state.ItemID} onChange={e => this.HandleChange(e, "ItemId")} className="form-control" id="itemId" />*/}
                        </div>
                        {this.state.ItemDesc != "" ? <div className="col-md-6  mb-3">
                            <label className="catalog-label" htmlFor="quantity">Description</label>
                            <input type="text" name="ItemDesc" value={this.state.ItemDesc} disabled="true" className="form-control" id="Description" />

                        </div> : null}
                        {this.state.ItemUOM != "" ? <div className="col-md-6  mb-3">
                            <label className="catalog-label" htmlFor="quantity">UOM</label>
                            <input type="text" name="ItemUOM" value={this.state.ItemUOM} disabled="true" className="form-control" id="UOM" />

                        </div> : null}
                        <div className="col-md-6  mb-3">
                            <label className="catalog-label mandatory-after" htmlFor="cost">Cost</label>
                            <input type="text" name="Cost" maxlength="10" value={this.state.Cost} onChange={e => this.HandleChange(e, "Cost")} className="form-control" id="cost" />

                        </div>
                        <div className="col-md-6  mb-3">
                            <label className="catalog-label mandatory-after" htmlFor="quantity">Quantity</label>
                            <input type="text" name="Quantity" maxlength="5" value={this.state.Quantity} onChange={e => this.HandleChange(e, "Quantity")} className="form-control" id="quantity" />

                        </div>
                        {/*<div className="col-md-6 mb-3">
                            <label className="catalog-label w-100">UOM</label>
                            <span style={{ "fontSize": "14px" }}><Select
                                id="UOMUnit"
                                name="UOMDD"
                                onChange={(e) => this.handleUOMChange(e)}
                                value={{ label: this.state.UOMName }}
                                options={this.state.UOMOptions}
                            /></span>
                        </div>*/}

                        {/*<div className="col-md-6  mb-3">
                            <label className="catalog-label" htmlFor="reference">Reference</label>
                            <select className="form-control" id="reference">
                                <option>Select</option>
                                <option>Option</option>
                            </select>
                        </div>*/}

                        <div className="col-md-12 ">
                            <label className="catalog-label mandatory-after">Locations</label>
                        </div>
                        <div className="col-md-2 mb-3">
                            <label className="catalog-label w-100">Area</label>

                            <span style={{ "fontSize": "14px" }}><Select
                                id="AreaId"
                                name="Area"
                                options={this.state.Area}
                                value={this.state.SelectedArea}
                                onChange={(e) => this.selectAreaChange(e)}
                                defaultValue="Select"
                            /></span>
                        </div>
                        <div className="col-md-2 mb-3">
                            {/*Bug - 2574 UI issue in Express putaway - Dhamotharan P*/}
                            <label className="catalog-label w-100">Aisle</label>

                            <span style={{ "fontSize": "14px" }}><Select
                                id="AreaId"
                                name="Area"
                                options={this.state.Aisle}
                                value={this.state.SelectedAisle}
                                onChange={(e) => this.selectAisleChange(e)}
                                defaultValue="Select"
                            /></span>
                        </div>

                        <div className="col-md-2 mb-3">
                            <label className="catalog-label w-100">Row</label>

                            <span style={{ "fontSize": "14px" }}><Select
                                id="AreaId"
                                name="Area"
                                options={this.state.Row}
                                value={this.state.SelectedRow}
                                onChange={(e) => this.selectRowChange(e)}
                                defaultValue="Select"
                            /></span>
                        </div>
                        <div className="col-md-2 mb-3">
                            <label className="catalog-label w-100">Shelf</label>

                            <span style={{ "fontSize": "14px" }}><Select
                                id="AreaId"
                                name="Area"
                                options={this.state.Shelf}
                                value={this.state.SelectedShelf}
                                onChange={(e) => this.selectShelfChange(e)}
                                defaultValue="Select"
                            /></span>
                        </div>
                        <div className="col-md-2 mb-3">
                            <label className="catalog-label w-100">Bin</label>

                            <span style={{ "fontSize": "14px" }}><Select
                                id="AreaId"
                                name="Area"
                                options={this.state.Bin}
                                value={this.state.SelectedBin}
                                onChange={(e) => this.selectBinChange(e)}
                                defaultValue="Select"
                            /></span>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="custom-control custom-checkbox item-custom-control">
                                <input type="checkbox" className="custom-control-input" id="customCheck-1" name="IsMakedefchk" checked={this.state.IsMakedefchk} onChange={e => this.HandleChange(e, "checkbox")} />
                                <label className="custom-control-label pt-1" htmlFor="customCheck-1">Make Default ?</label>
                            </div>
                        </div>
                        <div className="col-md-12 my-3 float-left pt-3">
                            <button className="btn btn-primary custom-btn-primary primary-btn px-4" onClick={e => this.SaveItemClick(e)} >Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    };
}
export default withTranslation()(ExpressPutAwayComponent);